var map = {
	"./additional_town_center.png": 71,
	"./african_monk.png": 72,
	"./arambai.png": 73,
	"./arbalester.png": 74,
	"./archer.png": 75,
	"./archery_range.png": 76,
	"./architecture.png": 77,
	"./arrowslits.png": 78,
	"./arson.png": 79,
	"./asian_monk.png": 80,
	"./atonement.png": 81,
	"./ballista_elephant.png": 82,
	"./ballistics.png": 83,
	"./banking.png": 84,
	"./barracks.png": 85,
	"./battering_ram.png": 86,
	"./battle_elephant.png": 87,
	"./berserk.png": 88,
	"./blacksmith.png": 89,
	"./blast_furnace.png": 90,
	"./block_printing.png": 91,
	"./bloodlines.png": 92,
	"./bodkin_arrow.png": 93,
	"./bombard_cannon.png": 94,
	"./bombard_tower.png": 95,
	"./bombard_tower_build.png": 96,
	"./bow_saw.png": 97,
	"./boyar.png": 98,
	"./bracer.png": 99,
	"./camel_archer.png": 100,
	"./camel_rider.png": 101,
	"./cannon_galleon.png": 102,
	"./capped_ram.png": 103,
	"./caravan.png": 104,
	"./caravel.png": 105,
	"./careening.png": 106,
	"./cartography.png": 107,
	"./castle.png": 108,
	"./castle_age.png": 109,
	"./cataphract.png": 110,
	"./cavalier.png": 111,
	"./cavalry_archer.png": 112,
	"./chain_barding_armor.png": 113,
	"./chain_mail_armor.png": 114,
	"./champion.png": 115,
	"./chemistry.png": 116,
	"./chu_ko_nu.png": 117,
	"./coinage.png": 118,
	"./condottiero.png": 119,
	"./conquistador.png": 120,
	"./conscription.png": 121,
	"./crop_rotation.png": 122,
	"./crossbowman.png": 123,
	"./defense.png": 124,
	"./demolition_raft.png": 125,
	"./demolition_ship.png": 126,
	"./dock.png": 127,
	"./double-bit_axe.png": 128,
	"./dry_dock.png": 129,
	"./eagle_scout.png": 130,
	"./eagle_warrior.png": 131,
	"./elephant_archer.png": 132,
	"./elite_arambai.png": 133,
	"./elite_ballista_elephant.png": 134,
	"./elite_battle_elephant.png": 135,
	"./elite_berserk.png": 136,
	"./elite_boyar.png": 137,
	"./elite_camel_archer.png": 138,
	"./elite_cannon_galleon.png": 139,
	"./elite_caravel.png": 140,
	"./elite_cataphract.png": 141,
	"./elite_chu_ko_nu.png": 142,
	"./elite_conquistador.png": 143,
	"./elite_eagle_warrior.png": 144,
	"./elite_elephant_archer.png": 145,
	"./elite_gbeto.png": 146,
	"./elite_genitour.png": 147,
	"./elite_genoese_crossbowman.png": 148,
	"./elite_huskarl.png": 149,
	"./elite_jaguar_warrior.png": 150,
	"./elite_janissary.png": 151,
	"./elite_kamayuk.png": 152,
	"./elite_karambit_warrior.png": 153,
	"./elite_keshik.png": 154,
	"./elite_kipchak.png": 155,
	"./elite_konnik.png": 156,
	"./elite_leitis.png": 157,
	"./elite_longboat.png": 158,
	"./elite_longbowman.png": 159,
	"./elite_magyar_huszar.png": 160,
	"./elite_mameluke.png": 161,
	"./elite_mangudai.png": 162,
	"./elite_organ_gun.png": 163,
	"./elite_plumed_archer.png": 164,
	"./elite_rattan_archer.png": 165,
	"./elite_samurai.png": 166,
	"./elite_shotel_warrior.png": 167,
	"./elite_skirmisher.png": 168,
	"./elite_steppe_lancer.png": 169,
	"./elite_tarkan.png": 170,
	"./elite_teutonic_knight.png": 171,
	"./elite_throwing_axeman.png": 172,
	"./elite_turtle_ship.png": 173,
	"./elite_unique_unit.png": 174,
	"./elite_war_elephant.png": 175,
	"./elite_war_wagon.png": 176,
	"./elite_woad_raider.png": 177,
	"./faith.png": 178,
	"./farm.png": 179,
	"./fast_fire_ship.png": 180,
	"./feitoria.png": 181,
	"./fervor.png": 182,
	"./feudal_age.png": 183,
	"./fire_galley.png": 184,
	"./fire_ship.png": 185,
	"./fish_trap.png": 186,
	"./fishing_ship.png": 187,
	"./fletching.png": 188,
	"./forging.png": 189,
	"./fortified_wall.png": 190,
	"./galleon.png": 191,
	"./galley.png": 192,
	"./gate.png": 193,
	"./gbeto.png": 194,
	"./genitour.png": 195,
	"./genoese_crossbowman.png": 196,
	"./gillnets.png": 197,
	"./gold_mining.png": 198,
	"./gold_shaft_mining.png": 199,
	"./guard_tower.png": 200,
	"./guilds.png": 201,
	"./halberdier.png": 202,
	"./hand_cannoneer.png": 203,
	"./hand_cart.png": 204,
	"./heated_shot.png": 205,
	"./heavy_camel_rider.png": 206,
	"./heavy_cav_archer.png": 207,
	"./heavy_demo_ship.png": 208,
	"./heavy_plow.png": 209,
	"./heavy_scorpion.png": 210,
	"./herbal_medicine.png": 211,
	"./heresy.png": 212,
	"./hoardings.png": 213,
	"./horse_collar.png": 214,
	"./house.png": 215,
	"./husbandry.png": 216,
	"./huskarl.png": 217,
	"./hussar.png": 218,
	"./illumination.png": 219,
	"./imperial_age.png": 220,
	"./imperial_camel_rider.png": 221,
	"./imperial_skirmisher.png": 222,
	"./iron_casting.png": 223,
	"./jaguar_warrior.png": 224,
	"./janissary.png": 225,
	"./kamayuk.png": 226,
	"./karambit_warrior.png": 227,
	"./keep.png": 228,
	"./keshik.png": 229,
	"./kipchak.png": 230,
	"./knight.png": 231,
	"./konnik.png": 232,
	"./krepost.png": 233,
	"./leather_archer_armor.png": 234,
	"./leitis.png": 235,
	"./light_cavalry.png": 236,
	"./long_swordsman.png": 237,
	"./longboat.png": 238,
	"./longbowman.png": 239,
	"./loom.png": 240,
	"./lumber_camp.png": 241,
	"./magyar_huszar.png": 242,
	"./mameluke.png": 243,
	"./man-at-arms.png": 244,
	"./mangonel.png": 245,
	"./mangudai.png": 246,
	"./market.png": 247,
	"./masonry.png": 248,
	"./meso_monk.png": 249,
	"./militia.png": 250,
	"./mill.png": 251,
	"./mining_camp.png": 252,
	"./missionary.png": 253,
	"./monastery.png": 254,
	"./monk.png": 255,
	"./murder_holes.png": 256,
	"./na.png": 257,
	"./onager.png": 258,
	"./organ_gun.png": 259,
	"./outpost.png": 260,
	"./padded_archer_armor.png": 261,
	"./paladin.png": 262,
	"./palisade_gate.png": 263,
	"./palisade_wall.png": 264,
	"./parthian_tactics.png": 265,
	"./petard.png": 266,
	"./pikeman.png": 267,
	"./plate_barding_armor.png": 268,
	"./plate_mail_armor.png": 269,
	"./plumed_archer.png": 270,
	"./rattan_archer.png": 271,
	"./redemption.png": 272,
	"./ring_archer_armor.png": 273,
	"./samurai.png": 274,
	"./sanctity.png": 275,
	"./sappers.png": 276,
	"./scale_barding_armor.png": 277,
	"./scale_mail_armor.png": 278,
	"./scorpion.png": 279,
	"./scout_cavalry.png": 280,
	"./shipwright.png": 281,
	"./shotel_warrior.png": 282,
	"./siege_engineers.png": 283,
	"./siege_onager.png": 284,
	"./siege_ram.png": 285,
	"./siege_tower.png": 286,
	"./siege_workshop.png": 287,
	"./skirmisher.png": 288,
	"./slinger.png": 289,
	"./spearman.png": 290,
	"./spies_or_treason.png": 291,
	"./squires.png": 292,
	"./stable.png": 293,
	"./steppe_lancer.png": 294,
	"./stone_mining.png": 295,
	"./stone_shaft_mining.png": 296,
	"./stone_wall.png": 297,
	"./supplies.png": 298,
	"./tarkan.png": 299,
	"./teutonic_knight.png": 300,
	"./theocracy.png": 301,
	"./throwing_axeman.png": 302,
	"./thumb_ring.png": 303,
	"./town_center.png": 304,
	"./town_patrol.png": 305,
	"./town_watch.png": 306,
	"./tracking.png": 307,
	"./trade_cart.png": 308,
	"./trade_cog.png": 309,
	"./transport_ship.png": 310,
	"./treadmill_crane.png": 311,
	"./trebuchet.png": 312,
	"./turtle_ship.png": 313,
	"./two-handed_swordsman.png": 314,
	"./two-man_saw.png": 315,
	"./unique_tech_1.png": 316,
	"./unique_tech_2.png": 317,
	"./unique_unit.png": 318,
	"./university.png": 319,
	"./villager.png": 320,
	"./war_elephant.png": 321,
	"./war_galley.png": 322,
	"./war_wagon.png": 323,
	"./watch_tower.png": 324,
	"./watch_tower_(tech).png": 325,
	"./wheelbarrow.png": 326,
	"./woad_raider.png": 327,
	"./wonder.png": 328,
	"./x.png": 329,
	"./x5.png": 330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 403;